/**
 * DMF type labels — shared between DMFPanel.tsx (modal) and the flat grid's
 * dmf_type array column (issue #585 Task 10.1), so both surfaces reuse one
 * map instead of duplicating it.
 */
export const DMF_TYPE_LABELS: Record<string, string> = {
  II: 'API',
  IV: 'Excipient',
};

/**
 * DMFPanel's own modal rendering — just the descriptive label ('API').
 */
export function formatDmfType(dmfType: string | null): string {
  if (!dmfType) return '—';
  return DMF_TYPE_LABELS[dmfType] ?? dmfType;
}

/**
 * Grid/search display format for the multi-value dmf_type array — "Type II
 * (API)" / "Type IV (Excipient)", per issue #585's Open Question 5.
 */
export function formatDmfTypeFull(dmfType: string): string {
  const label = DMF_TYPE_LABELS[dmfType];
  return label ? `Type ${dmfType} (${label})` : dmfType;
}

/**
 * dmf.DMF_Products.status is 'A' / 'I' (docs/features/fda-usdmf-integration.md
 * line 70) — expand to the full word everywhere it's shown to a user rather
 * than the raw code. Shared by DMFPanel.tsx (linked-record panel) and
 * externalLinkRecordAdapter.ts (Link to Source modal's search/review list).
 */
export function formatDmfStatus(status: string | null): string {
  if (status === 'A') return 'Active';
  if (status === 'I') return 'Inactive';
  return status ?? '—';
}
